import { filtersHelper } from "@/utils";

const bookingUser = (item = {}, external = false) => {
  const user = external ? item : item.user || {};
  return {
    uuid: user.uuid || item.uuid || "",
    name:
      user.name ||
      item.user_name ||
      [user.first_name, user.last_name].filter(Boolean).join(" ") ||
      "",
    email: user.email || item.user_email || "",
    isExternal: external,
  };
};

const bookingUsers = (data) => [
  ...(data.meeting_room_users || []).map((item) => bookingUser(item)),
  ...(data.meeting_room_user_external || []).map((item) =>
    bookingUser(item, true),
  ),
];

export const meetingRoomBookingModel = (data = {}) => ({
  uuid: data.uuid || "",
  meetingRoomUUID: data.meeting_room?.uuid || "",
  meetingRoomName: data.meeting_room?.name || "",
  companyUUID: data.meeting_room?.company?.uuid || "",
  companyName: data.meeting_room?.company?.name || "",
  bookingUsers: bookingUsers(data),
  agenda: data.agenda || "",
  description: data.description || "",
  start: data.start || "",
  end: data.end || "",
  startDisplay: filtersHelper.getDateTimeFormat(data.start),
  endDisplay: filtersHelper.getDateTimeFormat(data.end),
  isInterview: Boolean(data.is_interview),
  type: data.type == null ? null : Number(data.type),
  isActive: Boolean(data.is_active),
  attendees: data.meeting_room_users || [],
  externalAttendees: data.meeting_room_user_external || [],
  galleryGuests: data.gallery_guests || [],
  createdAt: filtersHelper.getDateTimeFormat(data.created_at),
});
